import { useState, useEffect } from 'react';

export interface UseAllowGuestResult {
  allowGuest: boolean;
}

/**
 * Hook for extracting AllowGuest flag from URL parameters.
 * Returns true when the URL contains AllowGuest=true (case-insensitive value check).
 */
export const useAllowGuest = (): UseAllowGuestResult => {
  const [allowGuest, setAllowGuest] = useState<boolean>(false);

  useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const param = urlParams.get('AllowGuest');
      setAllowGuest(param?.toLowerCase() === 'true');
    } catch {
      setAllowGuest(false);
    }
  }, []);

  return { allowGuest };
};
